import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"

import {
  FlexRow as FlexRowBase,
  BodyContainer as BodyContainerBase
} from "../../../shared"

export const IconsRow = styled.div`
  display: flex;
`

export const FlexRow = styled(FlexRowBase)`
  align-items: start;
  ${({isPrivate}) => isPrivate && "padding-top: 12px;"}
  ${minWidthMedia.tablet`
    ${({isPrivate}) => isPrivate && "padding-top: 0px;"}
  `}
`

export const BodyContainer = styled(BodyContainerBase)`
  margin-left: ${padding.tiny};
  ${minWidthMedia.tablet`
    margin-left: ${padding.base};
  `}
`
